package org.teddapp.project.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

/** Durées de micro-tâche : la feuille de route vise 5 à 10 minutes ; 15 et 25 restent possibles. */
val MICRO_TASK_DURATIONS: List<Int> = listOf(5, 10, 15, 25)

/**
 * Puces de durée en minutes. Toucher la puce active la désélectionne (durée inconnue).
 */
@Composable
fun TeddDurationChips(
    value: Int?,
    onChange: (Int?) -> Unit,
    modifier: Modifier = Modifier,
    options: List<Int> = MICRO_TASK_DURATIONS,
    label: String? = null,
) {
    Row(modifier = modifier, verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
        if (label != null) {
            Text(label.uppercase(), style = TeddType.Overline, color = TeddTokens.InkMuted, modifier = Modifier.padding(end = 2.dp))
        }
        options.forEach { min ->
            val selected = value == min
            Box(
                modifier = Modifier
                    .clip(RoundedCornerShape(TeddTokens.RFull))
                    .background(if (selected) TeddTokens.LimeStrong else TeddTokens.SurfaceSunken, RoundedCornerShape(TeddTokens.RFull))
                    .clickable(interactionSource = remember { MutableInteractionSource() }, indication = null) {
                        onChange(if (selected) null else min)
                    }
                    .padding(horizontal = 10.dp, vertical = 5.dp),
            ) {
                Text(
                    text = "$min min",
                    color = if (selected) TeddTokens.OnAction else TeddTokens.Ink,
                    fontSize = 12.sp,
                    fontWeight = FontWeight.SemiBold,
                )
            }
        }
    }
}
